import { render, staticRenderFns } from "./PolyIntegerReferenceUpdateScreen.vue?vue&type=template&id=8736579a&"
import script from "./PolyIntegerReferenceUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports